<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="pt1" epub:type="part" role="doc-part">
<header>
<h1 class="PN" id="pt1"><span aria-label="7" id="pg_7" role="doc-pagebreak"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample">PART I</span></span></h1>
</header>
<p class="PEP"><i>If you aren't in over your head, how do you know how tall you are?</i></p>
<p class="PEPC">—T. S. Eliot</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?7424bbda